<template>
  <div>
    <myheader></myheader>
    <van-image :src="require('../assets/img/about_banner.png')"/>
    <h1 style="font-size: 1.2rem; color: #333333; font-weight: normal; text-align: center;">关于我们</h1>
    <hr width="10%" style="border: 1px solid #000;">
    <div v-html="about" class="about_content">
    </div>
    <myfooter></myfooter>
  </div>
</template>

<script>
import {Field, Button, Cell, CellGroup, Toast, Swipe, SwipeItem, Image, Row, Col, Grid, GridItem} from 'vant'
import { getAboutContent } from '@/api'

export default {
  name: 'about',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Image.name]: Image,
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button,
  },
  data() {
    return {
      about: ''
    }
  },
  methods: {},
  mounted() {
    getAboutContent().then(res => {
      this.about = res
    })
  }
}
</script>

<style scoped>
.about_content {
  padding: 1rem 1.5rem 2.1rem;
  font-size: 0.78rem;
  font-weight: normal;
  color: #666666;
  line-height: 1.2rem;
}
</style>
